<template>
    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--md">

                    <!-- Header -->
                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-price-tag-3-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">{{ titlemodal }}</h4>
                                <p class="cf-modal-head__sub">Tarif par intervalle de quantité</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <!-- Body -->
                    <div class="cf-dialog-body">
                        <div class="space-y-2">
                            <label class="cf-field-label">Type de prix</label>
                            <div class="cf-select-wrap">
                                <select v-model="mypv.mtyprix" class="cf-inp cf-select">
                                    <option value="prixvente">{{ datainputlibelleforms.prixvente }}</option>
                                    <option value="prixvente1">{{ datainputlibelleforms.prixvente1 }}</option>
                                    <option value="prixvente2">{{ datainputlibelleforms.prixvente2 }}</option>
                                    <option value="prixvente3">{{ datainputlibelleforms.prixvente3 }}</option>
                                    <option value="prixvente4">{{ datainputlibelleforms.prixvente4 }}</option>
                                    <option value="prixvente5">{{ datainputlibelleforms.prixvente5 }}</option>
                                    <option value="prixvente6">{{ datainputlibelleforms.prixvente6 }}</option>
                                    <option value="prixvente7">{{ datainputlibelleforms.prixvente7 }}</option>
                                </select>
                                <i class="ri-arrow-down-s-line cf-select-arrow"></i>
                            </div>
                        </div>

                        <div class="mt-3 grid lg:grid-cols-2 gap-4">
                            <div class="space-y-2">
                                <label class="cf-field-label">Quantité minimum</label>
                                <input v-model="mypv.min" min="0" type="number" class="cf-inp" required>
                            </div>
                            <div class="space-y-2">
                                <label class="cf-field-label">Quantité maximum</label>
                                <input v-model="mypv.max" min="0" type="number" class="cf-inp" required>
                            </div>
                        </div>

                        <div class="space-y-2 mt-3">
                            <label class="cf-field-label">Prix de vente</label>
                            <input v-model="mypv.pu" min="0" type="number" class="cf-inp" required>
                        </div>
                    </div>

                    <!-- Footer -->
                    <div class="cf-dialog-foot">
                        <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                        <button @click="ajouterselectedmagasin" type="button" class="ti-btn ti-btn-primary-full">
                            <i class="ri-add-line align-middle"></i> Ajouter
                        </button>
                    </div>

                </div>
            </Transition>
        </div>
    </Transition>
</template>

<script>


    export default {
        /* eslint-disable */
        name: "formsupp",

        watch: {
            searchword: function(newvalue,oldvalue){

                this.page=1

            },
            searchtrierletableau: function(newvalue,oldvalue){

                this.page=1

               // console.log("  oldvalue  searchtrierletableau        **************** ",oldvalue)
               // console.log("  newvalue   searchtrierletableau       **************** ",newvalue)

            }

        },
        computed:{

            displayedPages() {
                const start = Math.max(1, this.page - 5);
                const end = Math.min(this.pages.length, start + 9);

                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },
            filterdatatable(){

                let mvalue=this.datatable;

                //this.page=this.Defaultpage;
                this.perPage=this.DefaultperPage;

               /* if (this.searchtrierletableau!==''){
                    let t=this;

                    mvalue = mvalue.filter( function (post) {

                        return   post.etatcontrat===parseFloat(t.searchtrierletableau)

                    })

                }*/


                if (this.searchword!==''){
                    let t=this;


                    mvalue = mvalue.filter( function (post) {
                        return    post.name.toLowerCase().includes(t.searchword.toLowerCase())
                        /*||
                        post.nameclient.toLowerCase().includes(t.searchword.toLowerCase()) ||
                        post.numbon.toLowerCase().includes(t.searchword.toLowerCase())*/
                    })

                }



                return this.paginate(mvalue) ;
            },
        },
        components: {

            /*appmenu,*/

        },

        data() {
            return {
                isdisplay:false,
                titlemodal:"",
                datapv:[],
                datainputlibelleforms:[],
                typedoc:"",
                messageerror:"",
                messagesucces:"",
                btnaction:"",

                mypv:{
                    min:0,
                    max:0,
                    mtyprix:'prixvente',
                    pu:0
                },
                indextable:0,


                searchword:"",
                searchtrierletableau:"",

                posts : [''],
                page: 1,
                // perPage: 100,
                perPage: 50,
                Defaultpage: 1,
                DefaultperPage: 50,
                pages: [],
            };
        },
        methods: {


            ajouterselectedmagasin(){

                if (parseFloat(this.mypv.min)>parseFloat(this.mypv.max)){
                    toastr['error']( "les quantités sont pas valide","<b></b>");

                    return
                }


                let countnbre=this.datapv.length
                let isok=0

                if (countnbre>0){

                    for (let i=0;i<countnbre;i++){

                        if(parseFloat(this.datapv[i].min)<=parseFloat(this.mypv.min)){

                            if(parseFloat(this.datapv[i].max)>=parseFloat(this.mypv.min)){

                                if(this.datapv[i].mtyprix===this.mypv.mtyprix){

                                    isok=1

                                }


                            }

                        }


                    }
//" Cette quantité est déjà comprise dans une des intervalles de quantités définir précédemment.  "
                    /* for (let i=0;i<countnbre;i++){

                         if(parseFloat(this.datapv[i].min)<=parseFloat(this.mypv.max)){

                             if(parseFloat(this.datapv[i].max)>=parseFloat(this.mypv.max)){

                                 isok=1

                             }

                         }


                     }*/



                    for (let i=0;i<countnbre;i++){

                        if(parseFloat(this.datapv[i].min)<=parseFloat(this.mypv.max)){

                            if(parseFloat(this.datapv[i].max)>=parseFloat(this.mypv.max)){

                                if(this.datapv[i].mtyprix===this.mypv.mtyprix){

                                    isok=1

                                }
                            }

                        }


                    }





                }



                else{isok=0}

                if (isok===1){
                    toastr['error']( "l'intervalle de quantité définie pour ce prix n'est pas valide.","<b></b>");

                    return
                }



                this.selected(this.btnaction,this.mypv)

                this.mypv={
                    min:0,
                    max:0,
                    pu:0,
                    mtyprix:'prixvente'
                }





            },



            close(){

                this.isdisplay=false;

            },




            selected(option,datavalue){




                this. mypv={
                    min:0,
                        max:0,
                        mtyprix:'prixvente',
                        pu:0
                }



                this.datapv.push(datavalue);


                // Suppose que vous avez un objet représentant l'élément sélectionné
                const elementSelectionne = { typ:option, value: this.datapv,index:this.indextable};

                // Émettre un événement personnalisé avec l'élément sélectionné
                this.$emit('elementSelectionnegestiontarifdevente', elementSelectionne);


                // Fermer le modal ou effectuer d'autres actions nécessaires
                this.isdisplay=false;
            },

            show(titlemodal,datainputlibelleforms,datapv,index,btnaction){
                this.messagesucces="";
                this.messageerror="";
                this.titlemodal=titlemodal
                this.btnaction=btnaction

                //this.datatable=listdata
                this.datainputlibelleforms=datainputlibelleforms
                this.datapv=datapv
                this.indextable=index
                this. mypv={
                    min:0,
                    max:0,
                    mtyprix:'prixvente',
                    pu:0
                }

                this.isdisplay=true;

            },






            //****************************************************************//

            setPages (posts) {
                this.pages=[];
                // let numberOfPages = Math.ceil(this.datatable.length / this.perPage);
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {

                    this.pages.push(index);
                }
            },
            paginate (posts) {

                this.setPages(posts)
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);

                let $res=posts.slice(from, to)

                if ($res.length>0){
                    return $res;
                }else{

                    return posts;
                }

                // return  posts.slice(from, to);
            }



        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:90vh; overflow:hidden; }
.cf-dialog--md { max-width:560px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.cf-field-label { display:block; font-size:0.72rem; text-transform:uppercase; letter-spacing:0.03em; font-weight:600; color:var(--cf-muted); margin-bottom:6px; }
.cf-inp { width:100%; height:40px; padding:0 12px; border-radius:var(--cf-radius-sm); border:1px solid rgb(var(--input-border,203 213 225)); background:#fff; color:var(--cf-ink); font-size:0.82rem; outline:none; transition:border-color 0.2s, box-shadow 0.2s; }
.cf-inp:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.cf-select-wrap { position:relative; }
.cf-select { appearance:none; padding-right:28px; cursor:pointer; }
.cf-select-arrow { position:absolute; right:10px; top:50%; transform:translateY(-50%); color:var(--cf-faint); pointer-events:none; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

@media (max-width:768px) { .cf-dialog--md { max-width:100%; } }
</style>
